import app from "flarum/forum/app";
import { extend } from "flarum/common/extend";
import Page from "flarum/common/components/Page";
const STORAGE_KEY = "xgayVisitorId";
const listeners = new Set();
let lastTrackedUrl = null;
let visitorId = null;
export function afterTracking(listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
function getVisitorId() {
  if (visitorId) return visitorId;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && stored.trim() && stored.length <= 100) visitorId = stored;
  } catch {
    // Storage can be unavailable; keep an ID for this page session instead.
  }
  if (!visitorId) {
    visitorId = window.crypto?.randomUUID?.() ?? Date.now().toString(36) + Math.random().toString(36).substring(2);
    try {
      localStorage.setItem(STORAGE_KEY, visitorId);
    } catch {
      // Tracking should still work when browser storage is blocked.
    }
  }
  return visitorId;
}
function trackPageView() {
  const url = window.location.pathname + window.location.search;
  if (url === lastTrackedUrl) return;
  lastTrackedUrl = url;
  void app.request({
    method: "POST",
    url: app.forum.attribute("apiUrl") + "/visitor-counter/track",
    body: {
      visitorId: getVisitorId()
    },
    errorHandler: () => {}
  }).then(() => {
    listeners.forEach(listener => listener());
  }).catch(() => {
    // Do not interrupt navigation or retry on redraws after a failed request.
  });
}
export default function initTracker() {
  setTimeout(trackPageView, 0);
  extend(Page.prototype, ["oncreate", "onupdate"], trackPageView);
}